/**
 * @generated SignedSource<<06e8e2d96bb7096b8e2a4ca2d790f8b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePageInput = {
  clientMutationId?: string | null;
  pageId: string;
};
export type FunnelEditFormContainer_PageMutation$variables = {
  input: DeletePageInput;
};
export type FunnelEditFormContainer_PageMutationVariables = FunnelEditFormContainer_PageMutation$variables;
export type FunnelEditFormContainer_PageMutation$data = {
  readonly deletePage: {
    readonly deletedPageId: string;
  } | null;
};
export type FunnelEditFormContainer_PageMutationResponse = FunnelEditFormContainer_PageMutation$data;
export type FunnelEditFormContainer_PageMutation = {
  variables: FunnelEditFormContainer_PageMutationVariables;
  response: FunnelEditFormContainer_PageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePagePayload",
    "kind": "LinkedField",
    "name": "deletePage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedPageId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelEditFormContainer_PageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FunnelEditFormContainer_PageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "97e0cb0c89514d89ba3a65a0b5341098",
    "id": null,
    "metadata": {},
    "name": "FunnelEditFormContainer_PageMutation",
    "operationKind": "mutation",
    "text": "mutation FunnelEditFormContainer_PageMutation(\n  $input: DeletePageInput!\n) {\n  deletePage(input: $input) {\n    deletedPageId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6c911065747660a4052e41b6fe9ec19";

export default node;
